// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__85TkX","tagButton":"styles_tagButton__LuNPN","icon":"styles_icon__iaqQ9","label":"styles_label__2yGEt"};